import styles from './EditProjectDevicesModal.module.css';

import { observer } from 'mobx-react-lite';
import { projectsStore } from '../../../../../store/mobx/projects.store';
import Modal from 'ui/Modal';
import FormSelect from 'ui/formItems/FormSelect/index';
import { FormProvider, useForm } from 'react-hook-form';
import { devicesStore } from 'store/mobx/devices.store';
import RegularButton from 'ui/RegularButton';
import { address_server_short, PUBLIC_ASSETS } from '../../../../../config';
import Icon from 'ui/Icon';
import useAlert from 'hooks/useAlert';

const EditProjectDevicesModal = observer(({ setModalOpened }) => {
  const { showAlert } = useAlert();
  const { selectedProject, upsertProjectDevices } = projectsStore;
  const { listDevices } = devicesStore;

  const defaultValues = selectedProject.devices?.reduce((acc, { device }) => {
    if (device) {
      acc[device.id_model] = device?.id;
    }
    return acc;
  }, {});

  const form = useForm({
    defaultValues: defaultValues,
  });

  const closeModal = () => setModalOpened(false);

  const handleSaveDevices = async (data) => {
    if (selectedProject?.devices.length) {
      const response = await upsertProjectDevices(data);
      if (!response.success && response.error_code) {
        return errorCommonAlert(response.error_code, response.error);
      }
    }
    closeModal();
  };

  const errorCommonAlert = (code, message) => {
    showAlert(`Код № ${code}${message ? ` - ${message}` : ''}.`, 'error');
  };

  const DeviceModel = ({ model, key }) => {
    const fieldName = `${model.device_model.id}`;
    const devicesForModel = listDevices.filter(
      (device) => device?.id_model === model.device_model?.id,
    );
    const deviceIcon = address_server_short + PUBLIC_ASSETS + model.device_model.image;

    return (
      <div className={styles.wrapperDeviceModel}>
        <div className={styles.deviceModel} key={key}>
          {model.device_model?.name}
        </div>
        <div
          style={{
            width: '400px',
            maxWidth: '400px',
          }}
        >
          <FormSelect
            name={fieldName}
            options={devicesForModel}
            renderOption={({ option }) => (
              <div className={styles.itemSelect}>
                <Icon width={30} height={30} src={deviceIcon} alt="оборудование" />
                <div
                  style={{
                    width: '85%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div className={styles.ellipsis}>{option.name}</div>
                  <div
                    style={{
                      display: 'flex',
                      color: 'grey',
                      fontSize: '13px',
                    }}
                  >
                    (инв.
                    <div
                      className={styles.ellipsis}
                      style={{
                        marginLeft: '0.5rem',
                      }}
                    >
                      {option?.inventory_number}
                    </div>
                    )
                  </div>
                </div>
              </div>
            )}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal hideDefaultFooter={true} title="Редактирование оборудования" onClose={closeModal}>
      <div className={styles.container}>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(handleSaveDevices)}>
            {selectedProject?.devices.length ? (
              selectedProject?.devices.map((model) => (
                <DeviceModel model={model} key={model.device_model.id} />
              ))
            ) : selectedProject?.id_scheme ? (
              <div className={styles.textInfo}>Оборудование в схеме отсутствует</div>
            ) : (
              <div className={styles.textInfo}>Не выбрана производственная схема</div>
            )}
            <div className={styles.buttonContainer}>
              <RegularButton
                className={styles.button}
                color="primary"
                variant="flat"
                text={selectedProject?.devices.length ? 'Сохранить' : 'Закрыть'}
              />
            </div>
          </form>
        </FormProvider>
      </div>
    </Modal>
  );
});

export default EditProjectDevicesModal;
